<template lang="pug">
  v-container(fluid grid-list-md)
    v-card
      v-toolbar.elevation-0(height="45" color="gray")
        v-toolbar-title {{ $t('pageHeader.reconcileLocation') }}
      v-card-title
        v-flex(md4)
          v-text-field(v-model='search', append-icon='search', label='Search', single-line, hide-details clearable)
      v-data-table(:headers='headers' item-key="id" :items='reconcile' :search="search" :loading='loading' :pagination.sync='pagination')
        template(slot='items' slot-scope='props')
          tr.pointer
            td.text-xs-left 
              div
                a(@click="gotoPageNewTab(props.item.storeID)") {{ props.item.Store.CSPID }}
                v-icon(small v-if="props.item.Store.isLocked") lock
            td.text-xs-left(@click="gotoPage(props.item.storeID)") {{ props.item.Store.businessName }}
            td.text-xs-left {{ props.item.Store.address }}
            //- td.text-xs-center(@click="gotoPage(props.item.storeID)") {{ props.item.Reconciles[0].chargeDuration.selector }}
            td.text-xs-center(@click="gotoPage(props.item.storeID)") {{ $moment(props.item.dueDate).format('MM/DD/YYYY') }}
            td.text-xs-right(@click="gotoPage(props.item.storeID)") {{ props.item.softwareFee | currency }}
            td.text-xs-left 
              a(@click="openLink(props.item.folderLink)") Folder Link
        
        v-alert(slot='no-results', :value='true', color='error', icon='warning')
          | Your search for "{{ search }}" found no results.
</template>

<script>
import reconcileService from "../service.js"

export default {
  data() {
    return {
      reconcile: [],
      headers: [
        {
          text: this.$t("labels.cspid"),
          value: "Store.CSPID",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.businessName"),
          value: "Store.businessName",
          sortable: true
        },
        {
          text: this.$t("labels.address"),
          value: "Store.address",
          sortable: true
        },
        {
          text: this.$t("labels.dueDate"),
          value: "dueDate",
          align: 'center',
          sortable: true,
        },
        {
          text: this.$t("labels.fee"),
          value: "softwareFee",
          align: 'center',
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.link"),
          value: "folderLink",
          align: 'center',
        }
      ],
      search: null,
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "id",
        descending: true
      }
    };
  },
  async created() {
    await this.getList();
  },
  methods: {
    gotoPageNewTab(id) {
      let routeData = this.$router.resolve({ path: `/location/profile/${id}`});
      window.open(routeData.href, '_blank');
    },
    openLink(data) {
      window.open(data, '_blank');
    },
    gotoPage(id) {
      this.$router.push({ path: `/location/profile/${id}` });
    },
    getList() {
      this.loading = true;
      reconcileService.getAll().then(response => {
        console.log("reconcileService response", response);
        this.reconcile = response.data;
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped>
</style>